<template>
<el-dialog title="凭证" :visible="pzFlag" width="1100px"   :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
  <div>
    <div style="margin-bottom:10px;" >
      <el-button type="primary" @click="dayinFn">打印</el-button>
      <el-button type="primary" @click="exportFn()" :disabled="isDisable">导出</el-button>
    </div>
    <hr>
    <div  id="printMe"  ref="print">
      <div v-if="ieMark==1">
        <h3 style="text-align: center;" v-if="invoiceMark==1">{{formatYearMonth(dataJson.businessDate)}}已开票与无票收入统计表</h3>
        <h3 style="text-align: center;" v-if="invoiceMark==2">{{formatYearMonth(dataJson.businessDate)}}未开票收入统计表</h3>
      </div>
      <div v-if="ieMark==2">
        <h3 style="text-align: center;" v-if="invoiceMark==1">{{formatYearMonth(dataJson.businessDate)}}已开票成本统计表</h3>
        <h3 style="text-align: center;" v-if="invoiceMark==2">{{formatYearMonth(dataJson.businessDate)}}未开票成本统计表</h3>
      </div>
      <table style="word-break:break-all;word-wrap:break-all;" class="sytable" v-if="tableList.length>0">
        <tr>
          <td style="width: 40px;">序号</td>
          <td style="width: 150px;">{{ieMark==1?'结算客户':'承运商'  }}</td>
          <td style="width: 100px;">项目名称</td>
          <td style="width: 100px;">业务类型</td>
          <td style="width: 60px;">结算量</td>
          <td style="width: 100px;">{{ ieMark==1?'应收金额(元)':'应付金额(元)'  }}</td>
          <td style="width: 60px;">税率(%)</td>
          <td style="width: 100px;">不含税金额(元)</td>
          <td style="width: 100px;" v-if="ieMark==1&&invoiceMark==1">是否开票</td>
          <td style="width: 100px;" v-if="invoiceMark==1">发票号</td>
          <td style="width: 100px;" v-if="invoiceMark==1">开票月份</td>

        </tr>
        <tr v-for="(item, index) in tableList" :key="index">
          <td >{{ index+1 }}</td>
          <td >{{ item.customerName ?item.customerName :'-'}}</td>
          <td >{{ item.projectType?item.projectType:'-' }}</td>
          <td >{{ item.businessName?item.businessName:'-'}}</td>
          <td >{{ item.liquidatedAmount?item.liquidatedAmount:'-'}}</td>
          <td >{{ item.amountReceivable?item.amountReceivable:'-'  }}</td>
          <td >{{ item.taxRate?item.taxRate:'-' }}</td>
          <td >{{ item.priceExcludTax ?item.priceExcludTax:'-'}}</td>
          <td   v-if="ieMark==1&&invoiceMark==1">{{ item.makeTicketYn ?item.makeTicketYn:'-'}}</td>
          <td v-if="invoiceMark==1">{{ item.invoiceOn ?item.invoiceOn:'-'}}</td>
          <td  v-if="invoiceMark==1">{{ item.invoiceMonth ?item.invoiceMonth:'-'}}</td>
        </tr>
      </table>
      <div class="AMarkFoot">
        <ul>
          <li>业务部门：{{dataJson.createSubdepartmentName}}</li>
          <li v-if="dataJson.auditTime">审核时间：{{dataJson.auditTime|dateFormat}}</li>
          <li v-if="!dataJson.auditTime">审核时间：-</li>
          <li>审核人(电子签名)：{{dataJson.auditUserName?dataJson.auditUserName:'-'}}</li>
        </ul>
      </div>
    </div>
  </div>
</el-dialog>
</template>
<script>
import { certificate } from '@/api/newTMS'
import { emptyFn, encryption, dateTimeFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  name: 'xiugaiSG',
  props: {
    pzFlag: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      isDisable: false,
      invoiceMark: this.rowData.invoiceMark, // 1：已开票与无票收入/已开票成本 2：未开票收入/未开票成本
      ieMark: this.rowData.ieMark, // 收支标记 1：收入 2：成本
      tableList: [],
      dataJson: {}
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    certificate({ id: this.rowData.id }).then(res => {
      this.loading = false
      this.tableList = res.tCustomerMonthlySummaryList
      this.dataJson = res.tAuditRecord ? res.tAuditRecord : {}
      this.dataJson.createSubdepartmentName = res.tCustomerMonthlySummary.createSubdepartmentName
      this.dataJson.businessDate = res.tCustomerMonthlySummary.businessDate
    }).catch(error => {
      this.$message.error(error.message)
    })
  },
  methods: {
    formatYearMonth (dateStr) {
    // 使用正则表达式匹配年和月
      const match = dateStr.match(/^(\d{4})-(\d{1,2})$/)
      if (!match) {
        throw new Error('日期格式不正确，应为 YYYY-MM')
      }

      const year = match[1]
      // 将月份字符串转为数字并去掉前导零
      const month = parseInt(match[2], 10)

      return `${year}年${month}月`
    },
    exportFn () {
      exportExcel(
        this.global.tmsPlus + '/customerMonthly/openCompleteTicketExportByTempExcel',
        { id: this.rowData.id },
        this.ieMark == 1 ? '月收入汇总' : '月成本汇总'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    dayinFn () {
      this.$print(this.$refs.print)
    },
    closeDialog () {
      this.$emit('update:pzFlag', false)
    }
  }

}
</script>

<style scoped lang='less'>
.AMarkFoot {
  font-size: 14px;
  bottom: 10px;
  width: 100%;
  ul {
    width: 100%;
    display: flex;
    margin: 10 !important;
    padding: 0 !important;
    justify-content: space-between;
    li {
      list-style: none;
      // flex: 1;
      // color: black;
    }
  }
}
.sytable {
  border-collapse: collapse;
}
.sytable,
.sytable th,
.sytable td {
  border: 1px solid #666;
}
.sytable {
  width: 100%;
  margin: 0 auto;
  margin-bottom: 10px;
  td {
    text-align: center;
    height: 30px;
  }
  .td1{
    width: 120px;
  }
  .td3{
    width:30%;
  }
  .td2{
    width:50%;
  }
}
.table_title p{
  text-align: center;
  font-size: 22px;
}
</style>
